import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditCardIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 2,
		y: 5,
		width: 20,
		height: 15,
		rx: 2,
		fill: "#003B6F"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M2 18.4375C2 19.2969 2.625 20 3.38889 20H20.6111C21.375 20 22 19.2969 22 18.4375V12.5H2V18.4375ZM7.55556 16.25H10.8889V17.5H7.55556V16.25ZM4.22222 16.25H6.44444V17.5H4.22222V16.25ZM20.6111 5H3.38889C2.625 5 2 5.70313 2 6.5625V8.75H22V6.5625C22 5.70313 21.375 5 20.6111 5Z",
		fill: "#FFD058"
	})]
});
export default SvgCreditCardIcon;
